import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import Icon from '../shared/Icon'

const Link = styled.a`
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 48px;
    width: 48px;
    border-radius: 100%;
`

const ActionLink = ({ tooltipId, tip, icon, handleClick }) => {

  return (
    <Link
      href="#"
      data-for={tooltipId}
      data-tip={tip}
      onClick={() => {
        handleClick()
      }}
    >
      <Icon src={icon} />
    </Link>
  )
}

ActionLink.defaultProps = {
  active: false
}

ActionLink.propTypes = {
  icon: PropTypes.string.isRequired,
  tooltipId: PropTypes.string.isRequired,
  tip: PropTypes.string,
  handleClick: PropTypes.func.isRequired
}

export default ActionLink
